export const environment = {
    production: true,
    apiUrl: 'https://api.hmg.ieqmanager.ieqcedsp.org.br'
};
